import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hideLocationHours',
  initialState: false,
  reducers: {
    setHideLocationHours(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHideLocationHours } = slice.actions;

export default slice.reducer;
